import React, { useState } from "react";
import { getCookie, reloadWindow, canUploadKyc } from "../../../Helpers/Utils";
import { useDispatch, useSelector } from "react-redux";
import Handler from "../../../Helpers/Components/Handler";
import NextPrev from "../../../Helpers/Components/NextPrev";
import White from "../../../Assets/images/white-bg.avif"
import { toast } from "react-toastify";
import { setAadhaar, setStep } from "../../../Reducer/customerSlice";
import Compressor from 'compressorjs';

const Aadhaar = (props) => {
    const person = getCookie('person')
    const aadhaar = useSelector(state => state?.customer?.aadhaar)
    const customer = useSelector(state => state?.customer?.customer)
    const [loading, setLoading] = useState(false)
    const [link, setLink] = useState("")
    const validAadhar = new RegExp('^[0-9]{12}');
    const [buttonHide, setButtonHide] = useState(true);
    const dispatch = useDispatch()
    const setSteps = () => dispatch(setStep(3))
    const copy = () => navigator.clipboard.writeText(link);
    const handleProofChange = (event) => dispatch(setAadhaar({ [event.target.name]: event.target.value }))
    const checkFileSize = (file, fieldName, previewKey) => {
        if (file.size > 4.5 * 1024 * 1024) {
            toast.error('Compressed image size exceeds 4.5 MB.');
        } else {
            dispatch(setAadhaar({ [fieldName]: file, [`${previewKey}`]: URL.createObjectURL(file), }));
        }
    };
    const compressImage = (file, fieldName, previewKey) => {
        new Compressor(file, {
            quality: 0.9,
            convertSize: 1 * 1024 * 1024,
            success(result) {
                checkFileSize(result, fieldName, previewKey);
            },
            error(err) {
                toast.error(err.message);
            },
        });
    };
    const handleImage = (event, previewKey) => {
        if (event.target.files[0]) {
            compressImage(event.target.files[0], [event.target.name], previewKey);
        }
    };
    const getLink = async () => {
        if (aadhaar?.aadhaar?.length !== 12) {
            toast.error("Invalid aadhaar number")
        } else if (!aadhaar?.aadhaarPhoto || !aadhaar?.aadhaarBackPhoto) {
            toast.error("Aadhar photos are required")
        } else {
            setLoading(true)
            const formData = new FormData();
            formData?.append("aadhaar", aadhaar?.aadhaar)
            formData?.append("aadhaar_photo", aadhaar?.aadhaar_photo)
            formData?.append("aadhaar_back_photo", aadhaar?.aadhaar_back_photo)
            const response = await Handler({ method: 'patch', url: `/customer/details/kyc/aadhar/${props?.customerId}`, data: formData, headers: { 'Content-Type': 'multipart/form-data' } })
            if (response?.success) {
                dispatch(setAadhaar({ aadhaar_photo: response?.data?.aadhaar_photo, aadhaar_back_photo: response?.data?.aadhaar_back_photo }))
                toast.success(response?.message)
                setButtonHide(false);
                window.DigiboostSdk({
                    gateway: "production",
                    token: response?.data?.token,
                    selector: "#digilocker-button",
                    onSuccess: async function (data) {
                        const fetchData = await Handler({
                            method: "patch",
                            url: `/customer/details/kyc/aadhar/link/verify/${props?.customerId}`,
                            data: { clientId: response?.data?.clientId }
                        });
                        if (fetchData?.success) {
                            toast.success(fetchData?.message || "Aadhaar verification successful");
                        } else {
                            toast.error(fetchData?.message || "Aadhaar verification failed");
                        }
                        setTimeout(() => {
                            reloadWindow()
                        }, 2000);
                    },

                    onFailure: function (error) {
                        console.log("Verification failed:", error);
                    }
                });
            } else {
                toast.error(response?.message)
            }
            setLoading(false)
        }
    }
    const handleNext = async () => {
        if (!aadhaar?.aadhaar && customer?.type === "Online") {
            toast.error("Aadhar Number is required")
        } else if (aadhaar?.aadhaar && !validAadhar.test(aadhaar?.aadhaar)) {
            toast.error("Aadhar Number is Invalid");
        } else if (!aadhaar?.aadhaar_photo && customer?.type === "Online") {
            toast.error("Aadhar Photo is required")
        } else if (!aadhaar?.aadhaar_back_photo && customer?.type === "Online") {
            toast.error("Aadhar Back Photo is required")
        } else {
            if (aadhaar?.aadhaar || aadhaar?.aadhaar_photo || aadhaar?.aadhaar_back_photo) {
                setLoading(true);
                const formData = new FormData()
                aadhaar?.aadhaar && formData.append('aadhaar', aadhaar?.aadhaar);
                aadhaar?.aadhaar_photo && formData.append('aadhaar_photo', aadhaar?.aadhaar_photo);
                aadhaar?.aadhaar_back_photo && formData.append('aadhaar_back_photo', aadhaar?.aadhaar_back_photo);
                const response = await Handler({ method: 'patch', data: formData, url: `/customer/details/fifth/update/${props?.customerId}`, headers: { 'Content-Type': 'multipart/form-data' } })
                if (response?.success) {
                    if (response?.data?.exist) {
                        toast.error(response?.data?.message)
                    }
                    dispatch(setAadhaar({ ...(response?.data?.aadhaar_photo ? { aadhaar_photo: response?.data?.aadhaar_photo } : {}), ...(response?.data?.aadhaar_back_photo ? { aadhaar_back_photo: response?.data?.aadhaar_back_photo } : {}) }))
                    dispatch(setStep(5));
                } else {
                    toast.error(response?.message);
                }
                setLoading(false)
            } else {
                dispatch(setStep(5))
            }
        }
    }
    return (
        <React.Fragment>
            <div className="row">
                <div className="col-md-6 col-xl-4">
                    <div className="form-label mb-3">Aadhaar Photo</div>
                    <div className="main-div mt-3">
                        <div className="btn-div">
                            {canUploadKyc(person, aadhaar?.aadhaarStatus, aadhaar?.aadhaar_photo) ? <label htmlFor="aadhaar_photo" className="me-2 upload-btn">Upload</label> : ""}
                            <button className="btn-warning btn btn-sm" onClick={() => { if (aadhaar?.aadhaarPhoto) { props?.setChosen(aadhaar?.aadhaarPhoto); props?.setProof(true) } }}>View</button>
                        </div>
                        <input type="file" accept="image/*" className="d-none" name="aadhaar_photo" id="aadhaar_photo" onChange={(e) => handleImage(e, "aadhaarPhoto")} />
                        <img src={aadhaar?.aadhaarPhoto || White} alt="Aadhaar" className="kycPhotoImg" />
                    </div>
                    <div className="main-div mt-3">
                        <div className="btn-div">
                            {canUploadKyc(person, aadhaar?.aadhaarStatus, aadhaar?.aadhaar_back_photo) ? <label htmlFor="aadhaar_back_photo" className="me-2 upload-btn">Upload</label> : ""}
                            <button className="btn-warning btn btn-sm" onClick={() => { if (aadhaar?.aadhaarBackPhoto) { props?.setChosen(aadhaar?.aadhaarBackPhoto); props?.setProof(true) } }}>View</button>
                        </div>
                        <input type="file" accept="image/*" className="d-none" name="aadhaar_back_photo" id="aadhaar_back_photo" onChange={(e) => handleImage(e, "aadhaarBackPhoto")} />
                        <img src={aadhaar?.aadhaarBackPhoto || White} alt="Aadhaar" className="kycPhotoImg" />
                    </div>
                </div>
                <div className="col-md-6 col-xl-4 mt-3 mt-md-0">
                    <div className="mb-3">
                        <label htmlFor="aadhaar" className="form-label"> Aadhaar </label>
                        <div className="input-group mb-3">
                            <input autoComplete="off" maxLength={12} disabled={loading || aadhaar?.aadhaarStatus || link} id="aadhaar" type="text" name="aadhaar" value={link ? link : (aadhaar?.aadhaar || "")} onChange={(e) => { if (/^\d{0,}$/.test(e.target.value)) { handleProofChange(e) } }} className="form-control input-theme text-uppercase" />
                            {
                                aadhaar?.aadhaarStatus ?
                                    <span className="input-group-text" id="basic-addon2"><i className="fa-solid fa-circle-check" style={{ color: 'green' }}></i></span> :
                                    <>{
                                        buttonHide ?
                                            <button
                                                className="btn btn-primary"
                                                onClick={getLink}
                                                disabled={loading}
                                            >
                                                {loading ? "Generating..." : "Generate Link"}
                                            </button>
                                            : ""
                                    }
                                    </>
                            }
                            <div id="digilocker-button" >

                            </div>
                        </div>
                    </div>
                    {
                        aadhaar?.aadhaarStatus && person === "admin" ? <button className="btn btn-sm btn-success ms-3" disabled={loading} onClick={() => { dispatch(setAadhaar({ aadhaarStatus: false })); setLink("") }}>{loading ? <i className="fa-solid fa-spinner fa-spin"></i> : "Update"}</button> : ""
                    }
                </div>
            </div>
            <NextPrev step={4} setStep={setSteps} last={7} onClick={handleNext} loading={loading} />
        </React.Fragment>
    )
}

export default Aadhaar